import React from "react";
import { Box, Typography, Divider } from "@mui/material";

const maroon = "#500000";

const PageHeader = ({
  title,
  subtitle,
  lastUpdated,
  tabs,
  actions,
  secondaryActions,
  actionButton,
  sx = {},
}) => {
  const headerActions = actions || actionButton;
  const supportingText = subtitle || (lastUpdated ? `Last Updated: ${lastUpdated}` : "");

  return (
    <Box sx={{ mb: 2, ...sx }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
          minHeight: 48,
          flexWrap: "wrap",
        }}
      >
        <Box sx={{ minWidth: 0, flex: "1 1 auto" }}>
          <Typography
            variant="h1"
            sx={{
              fontWeight: 700,
              color: maroon,
              mb: supportingText ? 1 : 0,
              fontSize: "28px",
              lineHeight: 1.25,
            }}
          >
            {title}
          </Typography>
          {supportingText && (
            <Typography variant="body2" sx={{ color: "#757575", fontWeight: 400, fontFamily: "'Brand Fonts', sans-serif" }}>
              {supportingText}
            </Typography>
          )}
        </Box>
        {(tabs || headerActions) && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: 2,
              flex: "0 1 auto",
              minHeight: 40,
              flexWrap: "wrap",
              "& .MuiTabs-root": {
                minHeight: 40,
              },
              "& .MuiTab-root": {
                minHeight: 40,
                py: 0,
              },
            }}
          >
            {tabs}
            {headerActions}
          </Box>
        )}
      </Box>
      {secondaryActions && (
        <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end", flexWrap: "wrap", gap: 2 }}>
          {secondaryActions}
        </Box>
      )}
      <Divider sx={{ mt: 2 }} />
    </Box>
  );
};

export default PageHeader;
